import React from "react";
import Header from "../Component/Header";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const Pricing = () => {
  document.title="InsightNest | Payment Plans Page";
  return (
    <>
    <Header/>
    <Helmet>
      <title>InsightNest | Payment Plans</title>
      <meta
        name="description"
        content="Get started with our simple, transparent pricing. Choose a plan that suits your needs."
      />
    </Helmet>
    <section
      id="pricing"
      className="bg-gradient-to-b from-violet-50 to-white py-20"
    >
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-16">
          Simple, Transparent Pricing
        </h2>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {/* Starter Plan */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-xl font-bold mb-4">Starter</h3>
            <div className="text-4xl font-bold mb-4">
              $5<span className="text-lg text-gray-500"></span>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>4 Ideas</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Report on Idea with Source</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Email Support</span>
              </li>
            </ul>
            <Link to={'/payment/starter'}>
            <button className="w-full py-3 border-2 border-black rounded-lg hover:bg-gray-50">
              Get Started
            </button>
            </Link>
          </div>

          {/* Pro Plan */}
          <div className="bg-black text-white p-8 rounded-xl shadow-lg relative">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-violet-600 text-white px-4 py-1 rounded-full text-sm">
              Most Popular
            </div>
            <h3 className="text-xl font-bold mb-4">Pro</h3>
            <div className="text-4xl font-bold mb-4">
              $10<span className="text-lg text-gray-400"></span>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>10 Ideas</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Report on Idea with Source</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Priority Support</span>
              </li>
            </ul>
            <Link to={'/payment/pro'}>
            <button className="w-full py-3 bg-white text-black rounded-lg hover:bg-gray-100">
              Get Started
            </button>
            </Link>
          </div>

          {/* Premium Plan */}
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <h3 className="text-xl font-bold mb-4">Premium</h3>
            <div className="text-4xl font-bold mb-4">
              $15<span className="text-lg text-gray-500"></span>
            </div>
            <ul className="space-y-4 mb-8">
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>16 Ideas</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Report on Idea with Source</span>
              </li>
              <li className="flex items-center gap-3">
                <i
                  data-lucide="check-circle"
                  className="w-6 h-6 text-green-500"
                ></i>
                <span>Priority Support</span>
              </li>
            </ul>
            <Link to={'/payment/premium'}>
            <button className="w-full py-3 border-2 border-black rounded-lg hover:bg-gray-50">
                Get Started
            </button></Link>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default Pricing;
